module.exports = __webpack_public_path__ + "media/images/ui-icons_888888_256x240-ef5ac6aea7df68591eec73ba300c86e5.png";